import React from 'react';
import {Card} from "../../../../components/card/card.jsx";
import {FaMars, FaVenus} from "react-icons/fa";
import DutyGarrisonStatus from "./duty-garrison-status.jsx";
import DutyIntendedFunction from "./duty-intended-function.jsx";
import DutyVehicleType from "./duty-vehicle-type.jsx";
import DashCard from "./dash-card.jsx";
import {fluidPx} from "../../../../utils/responsive-graph.js";
import useGraphViewportWidth from "../../../../hooks/use-graph-viewport-width.js";
import MetricDashCard from "../../../../components/dash-card/metric-dash-card.jsx";

const DutyGarrisonCard = ({ countersData, tableData, graphData }) => {
    const vw = useGraphViewportWidth();
    const iconSize = fluidPx(16, 34, vw);

    return (
        <Card className={"dash-main-card col-span-1 row-span-2"}>
            <Card.Header className={"border-b-0! bg-transparent"}>
                <Card.Title className={"bg-transparent text-white text-center w-full text-(length:--font-lg)! translate-y-1.5"}>Guarnições</Card.Title>
            </Card.Header>

            <Card.Body className={"flex-1 min-h-0 grid grid-rows-[auto_3fr_5fr_auto] gap-3 px-(--dash-pad-md)! pb-(--dash-pad-md)!"}>
                <section className={"grid grid-cols-12 gap-(--dash-gap-md)"}>
                    <MetricDashCard
                        counterCard
                        title="Guarnições ativas"
                        value={countersData?.garrison}
                        colSpan={5}
                        width="100%"
                        height="auto"
                        dashClassName="min-h-[80px]"
                    />

                    <DashCard className={"col-span-7 flex justify-between metric-dash-card py-2! px-4!"}>
                        <div className="translate-y-1">
                            <p className={"text-(length:--font-sm)! 2xl:text-(length:--font-md)! text-[#AAAAAA]! mb-1! font-light!"}>Efetivos ativos</p>
                            <h2 className={"text-(length:--font-lg)! 2xl:text-(length:--font-xl)! text-[#F4FFFF]! font-semibold!"}>{countersData?.contingents?.effective}</h2>
                        </div>

                        <section className={"flex gap-(--dash-gap-sm) content-center justify-items-center"}>
                            <div className={"flex gap-1 items-center"}>
                                <FaVenus size={iconSize} color={"#757575"}/> <h2 className={"text-(length:--font-lg)! 2xl:text-(length:--font-xl)!"}>{countersData?.contingents?.female}</h2>
                            </div>
                            <div className={"flex gap-1 items-center"}>
                                <FaMars size={iconSize} color={"#757575"}/> <h2 className={"text-(length:--font-lg)! 2xl:text-(length:--font-xl)!"}>{countersData?.contingents?.male}</h2>
                            </div>
                        </section>
                    </DashCard>
                </section>

                <DashCard className={"min-h-0"}>
                    <DutyGarrisonStatus
                        data={graphData.garrisonStatus}
                        height={"100%"}
                    />
                </DashCard>

                <DashCard className={"min-h-0"}>
                    <DutyIntendedFunction
                        garrisons={countersData?.garrison}
                        data={graphData.intendedFunction}
                        height={"100%"}
                    />
                </DashCard>

                <DashCard className={"min-h-0 flex flex-col"}>
                    <DutyVehicleType data={tableData.vehicleType} />
                </DashCard>
            </Card.Body>
        </Card>
    );
};

export default React.memo(DutyGarrisonCard);